import { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('norelio_cart') || '[]'); }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('norelio_cart', JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1, size = null) => {
    setItems(prev => {
      const existing = prev.find(i => i.id === product.id && i.size === size);
      if (existing) return prev.map(i => i.id === product.id && i.size === size ? { ...i, qty: i.qty + qty } : i);
      return [...prev, { ...product, qty, size }];
    });
  };

  const removeItem = (id, size = null) => setItems(prev => prev.filter(i => !(i.id === id && i.size === size)));

  const updateQty = (id, qty, size = null) => {
    if (qty < 1) return removeItem(id, size);
    setItems(prev => prev.map(i => i.id === id && i.size === size ? { ...i, qty } : i));
  };

  const clearCart = () => setItems([]);

  const total = items.reduce((sum, i) => sum + i.price * i.qty, 0);
  const count = items.reduce((sum, i) => sum + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clearCart, total, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
